__webpack_require__.p = "/themes/njam-2/";